module.exports = __webpack_public_path__ + "img/ic_chat_bubble_outline.ac2f4b1d.svg";